export const Footer = () => {
    return <div className="p-4 border-t-2 border-blue-600/30">
        <div className="container mx-auto">
            <div className="text-sm text-center text-black">Copyright © 2025-2026 NAVER AI Lab. All Rights Reserved.</div>
        </div>
    </div>
}